module.exports = __webpack_public_path__ + "assets/img/conecta_vertical.dbd8a9ca.png";